<script>
export default {
  props: {
    head: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    is_choose:{
      type: Boolean,
      default: false,
    }
  },
  computed: {
    fixed_right() {
      let arr = []
      arr = this.head.filter(item => item.fixed == 'right')
      return arr
    },
    fixed_left() {
      let arr = []
      arr = this.head.filter(item => item.fixed == 'left')
      return arr
    }
  },
  data() {
    return {
      all_choose: false,
      table_item_height: [],
      table_fixed_ref: 'fixed_element_box' + new Date().getTime(),
      order_table_ref: 'order_table_box' + new Date().getTime(),
      order_table_thead_ref: 'order_table_thead' + new Date().getTime(),
      order_content_box_ref: 'order_content_box' + new Date().getTime(),
      table_scroll_config: {
        show: false,
        scroll_width: '',
        bar_width: '',
        p_bottom: 0,
        scroll_height: 6,
        spacing: 10
      },
      fixed_right_show: {
        head: false,
        body: false
      },
      mouse_enter_index: -1
    }
  },
  watch: {
    data: {
      handler(newVal, oldVal) {
        if (newVal.length) {
          if(this.fixed_right.length || this.fixed_left.length){
            this.initTableVirtualScrollBar()
          }
          if (this.fixed_right.length) {
            this.fixed_right_show.head = true
            this.initTableItemHeight()
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    initTableVirtualScrollBar() {
      this.$nextTick(() => {
        let fixed_element_box = this.$refs[this.table_fixed_ref]
        let order_table_thead = this.$refs[this.order_table_thead_ref]
        this.table_scroll_config.bar_width = order_table_thead.offsetWidth
        this.table_scroll_config.scroll_width = fixed_element_box.offsetWidth
        let table_size = fixed_element_box.getBoundingClientRect()
        let is_max_bottom = window.innerHeight - table_size.bottom
        this.table_scroll_config.p_bottom = is_max_bottom < 0 ? window.innerHeight - table_size.top - this.table_scroll_config.spacing : table_size.height
        this.table_scroll_config.show = true
      })
    },
    handleTableScroll(e) {
      let scroll_left = e.target.scrollLeft
      this.$refs[this.order_table_ref].scrollTo({
        top: 0, // 垂直滚动的像素数
        left: scroll_left, // 水平滚动的像素数
        behavior: 'instant' // 滚动行为：'smooth' 平滑滚动，'instant' 即时滚动，'auto' 自动
      });
    },
    initTableItemHeight() {
      this.$nextTick(() => {
        let order_content_box = this.$refs[this.order_content_box_ref]
        order_content_box.forEach((item, index) => {
          this.$set(this.table_item_height, index, item.clientHeight)
          this.fixed_right_show.body = true
        })
      })
    },
    handleMouseEnter(index){
      this.mouse_enter_index = index
    },
    handleMouseLeave(index){
      this.mouse_enter_index = -1
    },
    handleAllChoose(){
      this.data.forEach(item => {
        item.is_choose = this.all_choose
        if(item.is_choose)this.$emit('handleDataChoose',item)
      })
    },
    handleChoose(order){
      this.$emit('handleDataChoose',order)
      this.all_choose = this.data.every(item => item.is_choose)
    }
  }
}
</script>

<template>
  <!-- 进行定位的固定元素盒子 -->
  <div class="fixed_element_box" :ref="table_fixed_ref">
    <!-- 表格内容 -->
    <div class="order_table_box" :ref="order_table_ref">
      <!-- 表头 -->
      <div class="order_table_thead" :ref="order_table_thead_ref">
        <!-- 表头全选 -->
        <div class="order_table_thead_item center all_choose_box" v-if="is_choose">
          <el-checkbox v-model="all_choose" @change="handleAllChoose"></el-checkbox>
        </div>
        <!-- 正常表头项 -->
        <div v-for="(item) in head" :key="item.key" :style="{'flex': item.width ? `0 0 ${item.width}` : 1}"
          :class="['order_table_thead_item','center',item.key]">{{ item.fixed? '' : item.label}}</div>
        <!-- 隔开右侧定位 -->
        <div v-if="fixed_right.length" class="order_table_thead_item" style="width: 20px;"></div>
      </div>
      <!-- 表格内容项 -->
      <div class="order_table_tbody">
        <!-- 表格为空时 -->
        <No v-if="data.length === 0" />
        <div class="order_item_box" :style="{backgroundColor:mouse_enter_index == order_index ? '#F5F7FA' : '#fff'}" @mouseenter="handleMouseEnter(order_index)" @mouseleave="handleMouseLeave(order_index)" v-for="(order,order_index) in data" :key="order.id">
          <!-- 横跨整行的信息栏 -->
          <div class="order_sn_table">
            <slot name="_row" :row="order" :_index="order_index"></slot>
          </div>
          <!-- 具体表格元素 -->
          <div class="order_content_box" :ref="order_content_box_ref">
            <!-- 单选格 -->
            <div class="order_table_tbody_cell center choose_box" v-if="is_choose">
              <el-checkbox v-model="order.is_choose" @change="handleChoose(order)"></el-checkbox>
            </div>
            <!-- 渲染单元格 -->
            <div :class="['order_table_tbody_cell']" v-for="(item) in head" :key="item.key"
              :style="{'flex': item.width ?  `0 0 ${item.width}` : '1 1 auto'}">
              <slot v-if="!item.fixed" :name="item.key" :row="order" :_index="order_index"></slot>
            </div>
          </div>
        </div>
        <!-- 隔开右侧定位 -->
        <div v-if="fixed_right.length" class="order_item_box" style="width: 20px;"></div>
      </div>
    </div>
    <!-- 右侧固定 -->
    <div class="order_table_box order_fixed_right" v-if="fixed_right_show.head">
      <div class="order_table_thead" v-for="(item) in fixed_right" :key="item.key">
        <div class="order_table_thead_item center cz">操作</div>
      </div>
      <div v-if="fixed_right_show.body">
        <div class="order_table_tbody" v-for="(item,i) in fixed_right" :key="item.key + i">
          <div class="order_item_box" v-for="(order,order_index) in data" :key="order.id" :style="{backgroundColor:mouse_enter_index == order_index ? '#F5F7FA' : '#fff'}" @mouseenter="handleMouseEnter(order_index)" @mouseleave="handleMouseLeave(order_index)">
            <div class="order_sn_table"></div>
            <div class="order_content_box"
              :style="{height:table_item_height[order_index] ? table_item_height[order_index] + 'px' : '0px'}">
              <div class="order_table_tbody_cell center cz">
                <slot :name="item.key" :row="order" :_index="order_index"></slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 虚拟滚动条 -->
    <div class="virtual_scroll_bar" @scroll="handleTableScroll" v-if="table_scroll_config.show"
      :style="{width: table_scroll_config.scroll_width + 'px',height: table_scroll_config.scroll_height + 'px',top: (table_scroll_config.p_bottom - table_scroll_config.scroll_height) + 'px'}">
      <div class="virtual_scroll_bar_content" :style="{width: table_scroll_config.bar_width + 'px'}"></div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.fixed_element_box {
  position: relative;
  .order_table_box {
    width: 100%;
    overflow-x: auto;
    padding-top: 60px;
    position: relative;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    &::-webkit-scrollbar {
      display: none;
    }
    .order_table_thead {
      min-width: 100%;
      padding: 0 4px;
      flex-grow: 1;
      height: 60px;
      display: flex;
      align-items: stretch;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      background-color: #f7f8fa;
      .order_table_thead_item {
        font-size: 14px;
        color: #666;
        white-space: nowrap;
        min-width: 80px;
      }
      .all_choose_box {
        flex: 0 0 60px;
      }
    }
    .order_table_tbody {
      flex-grow: 1;
      min-width: 100%;
      .order_item_box {
        min-width: 100%;
        width: fit-content;
        display: flex;
        flex-direction: column;
        background-color: #fff;
        margin-top: 8px;
        .order_sn_table {
          flex-grow: 1;
          width: 100%;
          height: 40px;
          display: flex;
          align-items: center;
          background-color: #f7f8fa;
          font-size: 12px;
          color: #333333;
          white-space: nowrap;
        }
        .order_content_box {
          flex-grow: 1;
          display: flex;
          align-items: stretch;
          position: relative;
          padding: 8px 4px;
          .order_table_tbody_cell {
            width: 100%;
            min-width: 80px;
            text-align: center;
          }
          .choose_box {
            flex: 0 0 60px;
          }
        }
      }
    }
  }
  .order_fixed_right {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
    padding-top: 60px;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    width: fit-content;
    box-shadow: 0px 4px 24px 0px rgba(76, 100, 255, 0.2);
    .order_table_thead,
    .order_table_tbody,
    .order_item_box {
      width: 100% !important;
      min-width: 120px;
    }
    .order_table_tbody .order_item_box{
      background-color: #fff;
    }
    .order_table_thead_item{
      flex: 1;
      min-width: 80px;
    }
  }
  .virtual_scroll_bar {
    position: absolute;
    left: 0;
    z-index: 2;
    overflow-x: auto;
    background-color: #f7f8fa;
    .virtual_scroll_bar_content {
      height: 1px;
    }
    &::-webkit-scrollbar {
      height:6px;
      border-radius: 9999rpx;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(76, 100, 255, 0.2);
      border-radius: 9999rpx;
    }
  }
}
</style>